<template>
  <div>
    <div class="subcription-modal-container">
      <!-- head container  -->
      <div class="head-subscription-row">
        <div>
          <div>
            <h4>Subscription</h4>
            <p>
              Pause or cancel <br />
              at any time
            </p>
          </div>
        </div>
        <div>
          <div>
            <p>1 test delivered every</p>
            <select name="" id="" v-model="interval">
              <option v-for="option in product.subscription_options" :key="option.body"
                :value="option.body.split(' ')[0]">
                {{ option.body }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <!-- head container -->

      <div class="subscription-container">
        <h5>By subscribing you can :</h5>
        <ul>
          <li><span>Track your results over time</span></li>
          <li><span>Monitor Health conditions</span></li>
          <li>
            <span>Understand how your lifestyle affects your health</span>
          </li>
        </ul>
      </div>

      <!-- Pricing container -->
      <div class="pricing-container hr-border">
        <div class="subcription-price-row">
          <div>
            <label class="custom-radio">
              <input v-model="mode" name="type" value="subscription" type="radio" />
              <span class="checkmark"></span>
            </label>
            <p>Subscription price</p>
            <p>Save 10%</p>
          </div>
          <div>
            <span class="gap-1"> {{ productPrice }}</span>
            <p>{{ subscription }}</p>
          </div>
        </div>
      </div>

      <h3 class="feature-head">One-off purchase</h3>

      <div class="pricing-container">
        <div class="subcription-price-row">
          <div>
            <label class="custom-radio">
              <input value="payment" name="type" v-model="mode" type="radio" />
              <span class="checkmark"></span>
            </label>
            <p>One-off purchase</p>
            <p>One-off purchase</p>
          </div>
          <div>
            <p>{{ productPrice }}</p>
          </div>
        </div>
      </div>
      <!-- Pricing container -->

      <div class="d-flex flex-column gap-3">
        <button type="button" class="btn btn-primary w-100" @click="checkout">Checkout</button>
        <button class="btn" @click="back">Back</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import "@/styles/pages/BloodTestDetails.scss";
import { getPrice, getSubscriptionPrice } from "@/services/price.js";
import { ref, computed, defineProps, defineEmits } from "vue";

const props = defineProps({
  product: Object,
  collectionMethod: String
})

const emits = defineEmits(['back', 'openCheckoutModal']);

const interval = ref("3");
const mode = ref("subscription");

const subscription = computed(() => {
  return getSubscriptionPrice(props.product);
});

const productPrice = computed(() => {
  if (getPrice(props.product) === undefined && props.product.variants) {
    if (props.product?.variants[0].price && props.product?.variants[0].price.isOnSale) {
      return props.product?.variants[0].currencySymbol.raw + props.product?.variants[0].price.sale / 100;
    }
    if (props.product?.variants[0].price && props.product?.variants[0].price.base) {
      return props.product?.variants[0].currencySymbol.raw + props.product?.variants[0].price.base / 100;
    }
    return 0;
  } else {
    return getPrice(props.product);
  }
});

const back = () => {
  emits("back");
}

const checkout = () => {
  emits("openCheckoutModal", {
    mode: mode.value,
    interval: interval.value,
    collectionMethod: props.collectionMethod,
  });
}
</script>
